export default __webpack_public_path__ + "static/media/keyboardPRO.4ae4f1a3.jpg";